"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AaIconTypes = void 0;
var AaIconTypes = {
  RECENT_SEARCH: "RECENT_SEARCH",
  NEAREST_AIRPORT: "NEAREST_AIRPORT",
  FLIGHT_ICON: "FLIGHT_ICON",
  FLIGHT_ICON_BLUE: "FLIGHT_ICON_BLUE",
  CITY_TRANSFER: "CITY_TRANSFER",
  ISLAND_TRANSFER: "ISLAND_TRANSFER",
  OTHER_AIRLINES: "OTHER_AIRLINES",
  SWAP_ICON: "SWAP_ICON",
  CLOSE_ICON: "CLOSE_ICON",
  ARROW_LEFT: "ARROW_LEFT",
  ARROW_RIGHT: "ARROW_RIGHT",
  ARROW_RIGHT_WHITE: "ARROW_RIGHT_WHITE",
  ARROW_DROPDOWN: "ARROW_DROPDOWN",
  LOCATION: "LOCATION",
  CALENDAR: "CALENDAR",
  WARNING_ICON: "WARNING_ICON",
  AIRPORT: "AIRPORT",
  POI: "POI",
  NAV_BACK_WHITE_ICON: "NAV_BACK_WHITE_ICON",
  NO_RESULTS: "NO_RESULTS"
};
exports.AaIconTypes = AaIconTypes;
var _default = AaIconTypes;
exports["default"] = _default;